import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Bundle all locale files synchronously. ~50 KB gzipped, but guarantees
// translations are available immediately (no fetch race conditions during
// prerender, no flash of untranslated content at runtime).
import enCommon from '@/locales/en/common.json'
import itCommon from '@/locales/it/common.json'
import esCommon from '@/locales/es/common.json'
import deCommon from '@/locales/de/common.json'
import frCommon from '@/locales/fr/common.json'

export const supportedLanguages = ['en', 'it', 'es', 'de', 'fr'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]
export const defaultLanguage: SupportedLanguage = 'en'

const resources = {
  en: { common: enCommon },
  it: { common: itCommon },
  es: { common: esCommon },
  de: { common: deCommon },
  fr: { common: frCommon },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLanguage,
    supportedLngs: supportedLanguages,
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },

    ns: ['common'],
    defaultNS: 'common',

    react: {
      useSuspense: false,
    },
  })

export default i18n
